import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { LoaderHandlerService } from '../utilities/loader-handler.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService {
  private dataTablesEndpoint = 'https://devgtw.coure-tech.com/'; // Replace with your DataTables endpoint URL

  constructor(public spinnerHandler: LoaderHandlerService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.spinnerHandler.handleRequest('plus');

   // alert("df")
    return next
      .handle(request)
      .pipe(
        finalize(this.finalize.bind(this))
      );
  }

  finalize = (): void => this.spinnerHandler.handleRequest();

  // constructor(
  //   public spinnerHandler: LoaderHandlerService
  // ) { }

  // intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
  //   if (this.isDataTablesSearchRequest(request)) {
  //     return next.handle(request);
  //   }

  //   this.spinnerHandler.handleRequest('plus');
  //   return next.handle(request).pipe(finalize(this.finalize.bind(this)));
  // }

  // finalize = (): void => this.spinnerHandler.handleRequest();

  // private excludedURLs: string[] = [
  //   'https://devgtw.coure-tech.com/',
  //   // '/api/VasService/getservices',
  //   // 'api/QuizUsers/getquizusersresponse',
  //   // '/api/other/endpoint',
  //   // '/api/some/other/endpoint'
  // ];

  // private isDataTablesSearchRequest(request: HttpRequest<unknown>): boolean {
  //   const isSearchRequest = (
  //     request.method === 'GET' &&
  //     request.params.has('search') &&
  //     request.params.get('search') === ''
  //   );
  //   const isDataTableEndpoint = this.excludedURLs.some(endpoint => request.url.includes(endpoint));
  //   return !isSearchRequest || !isDataTableEndpoint;
  // }


}
